import React from 'react';
import { MapPin, Clock } from 'lucide-react';

interface VenueBabySectionProps {
  venue: any;
  language: 'en' | 'mr';
}

export const VenueBabySection: React.FC<VenueBabySectionProps> = ({ venue, language }) => {
  return (
    <section className="relative py-24 px-4 bg-gradient-to-b from-white to-yellow-50">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-center text-4xl font-black text-transparent bg-clip-text bg-gradient-to-r from-yellow-500 to-pink-500 mb-12">
          {language === 'mr' ? '📍 पार्टी विवरण' : '📍 Party Details'}
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="bg-white rounded-2xl shadow-lg p-8 border-4 border-yellow-300 text-center transform hover:scale-105 transition-transform">
            <Clock className="w-12 h-12 mx-auto mb-4 text-yellow-500" />
            <p className="text-gray-500 text-sm uppercase font-bold mb-2">
              {language === 'mr' ? 'तारीख' : 'Date'}
            </p>
            <p className="text-2xl font-black text-yellow-600">
              {language === 'mr' ? venue.dateMr : venue.dateStr}
            </p>
            <p className="text-lg font-bold text-pink-600 mt-2">
              {venue.time}
            </p>
          </div>

          <div className="bg-white rounded-2xl shadow-lg p-8 border-4 border-pink-300 text-center transform hover:scale-105 transition-transform">
            <MapPin className="w-12 h-12 mx-auto mb-4 text-pink-500" />
            <p className="text-gray-500 text-sm uppercase font-bold mb-2">
              {language === 'mr' ? 'स्थान' : 'Location'}
            </p>
            <p className="text-lg font-black text-gray-800 line-clamp-2">
              {language === 'mr' ? venue.venueMr : venue.venue}
            </p>
            <button className="mt-4 px-4 py-2 bg-gradient-to-r from-blue-400 to-cyan-400 text-white font-bold rounded-lg text-sm hover:shadow-lg transition-all">
              📍 {language === 'mr' ? 'नक्शा देखें' : 'View Map'}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};
